<template>
  <div class="main">
    <!-- <ax-banner></ax-banner> -->
    <ax-content></ax-content>
  </div>
</template>
<script>

// import AXbanner from './components/AXbanner.vue'
import AXcontent from './components/AXcontent.vue'
export default {
  components: {
    // 'ax-banner': AXbanner,
    'ax-content': AXcontent,
  }
}
</script>
<style lang="scss" scoped>

</style>